import { mountLegendPanel } from './legend-panel.js';
import { mountOverviewPanel } from './overview-panel.js';
import { mountSourcesPanel } from './sources-panel.js';
import { mountSettingsPanel, unmountSettingsPanel } from './settings-panel.js';

export function closeNewsGraph() {
  document.body.classList.remove('news-graph-active');
  const newsGraphWrapper = document.getElementById('news-graph-wrapper');
  if (newsGraphWrapper) newsGraphWrapper.remove();
  
  const legendPanel = document.getElementById('news-graph-legend-vr');
  if (legendPanel) legendPanel.remove();

  unmountSettingsPanel();
  
  const overviewPanelWrapper = document.getElementById('news-graph-overview-vr-wrapper');
  if (overviewPanelWrapper) overviewPanelWrapper.remove();
  
  const leftOverview = document.getElementById('news-graph-overview-vr-left');
  if (leftOverview) leftOverview.remove();

  const rightOverview = document.getElementById('news-graph-overview-vr-right');
  if (rightOverview) rightOverview.remove();


  const leftPanel2 = document.querySelector('#left-panel-2');
  if (leftPanel2) {
    const s1 = leftPanel2.querySelector('#news-screen-1');
    if (s1) {
      s1.setAttribute('visible', true);
      s1.setAttribute('position', '0 0 0.02');
    }
    
    const sourcesPanel = leftPanel2.querySelector('#news-graph-sources-vr');
    if (sourcesPanel) sourcesPanel.remove();
  }

  const rightPanel = document.querySelector('#right-container');
  if (rightPanel) {
    const rightOverview = rightPanel.querySelector('#news-graph-overview-vr-right');
    if (rightOverview) rightOverview.remove();

    const header = rightPanel.querySelector('.main-header');
    if (header) {
      header.setAttribute('visible', true);
      header.setAttribute('position', '0 0.005 0');
    }

    const rc = rightPanel.components['right-container-control'];
    if (rc && rc.topMenuButtons && rc.topMenuButtons[0]) {
      rc.topMenuButtons[0].click();
    }
  }
}

export function openNewsGraph() {
  if (window.VRPanelsSlidingManager) {
    window.VRPanelsSlidingManager.setSelectedEl(null);
  }
  document.body.classList.add('news-graph-active');
  const chartTypeEl = document.querySelector('[chart-type-control]');
  if (chartTypeEl && chartTypeEl.components['chart-type-control']) {
    chartTypeEl.components['chart-type-control'].clearSelection();
  }

  const centerPanel = document.getElementById("large-center-panel");
  if (!centerPanel) return;
  
  if (typeof window.animateDockVisibility === 'function') {
    window.animateDockVisibility(false);
  }
  
  const centerPanelContent = document.getElementById("large-center-panel-content") || centerPanel;

  const existingZeroPlane = document.querySelector('#zero-plane');
  if (existingZeroPlane) {
    existingZeroPlane.setAttribute('visible', false);
  }

  const stockCubeWrapper = document.getElementById('stock-3d-cube-wrapper');
  if (stockCubeWrapper) {
    stockCubeWrapper.remove();
  }

  let wrapper = document.getElementById(`news-graph-wrapper`);
  if (!wrapper) {
    wrapper = document.createElement("a-box");
    wrapper.setAttribute("id", `news-graph-wrapper`);
    wrapper.setAttribute("width", 0.75);
    wrapper.setAttribute("height", 0.75);
    wrapper.setAttribute("depth", 0.75);
    wrapper.setAttribute("material", `opacity: 0; transparent: true; side: back; depthTest: false`);
    wrapper.setAttribute("position", "-0.25 0.2 -0.25");
    wrapper.setAttribute("rotation", "30 45 0");
    wrapper.setAttribute("news-graph-rotation", "target: #news-graph-wrapper");
    wrapper.setAttribute("data-raycastable", "");
    wrapper.addEventListener('click', (evt) => {
      if (evt.target === wrapper) {
        const newsGraphEl = document.getElementById('news-graph');
        const comp = newsGraphEl && newsGraphEl.components['news-graph-vr'];
        if (comp && !comp._nodeClickedThisFrame) {
          comp.setSelectedNodeEl(null);
        }
      }
    });
    centerPanelContent.appendChild(wrapper);

    const newsGraphCube = document.createElement("a-entity");
    newsGraphCube.setAttribute("id", "news-graph");
    newsGraphCube.setAttribute("news-graph-vr", "");
    wrapper.appendChild(newsGraphCube);
  }

  if (typeof window.addBannerAndRotationControls === 'function') {
    window.addBannerAndRotationControls("News Graph", "0.0 45 0", "0 .58 0", "0.023", "0 0 0.02", "news-graph");
  }

  mountLegendPanel();
  mountOverviewPanel();
  mountSourcesPanel();
  mountSettingsPanel();


  const leftPanel2 = document.querySelector('#left-panel-2');
  if (leftPanel2) {
    const s1 = leftPanel2.querySelector('#news-screen-1');
    const s2 = leftPanel2.querySelector('#news-screen-2');
    if (s1) {
      s1.setAttribute('visible', true);
      s1.setAttribute('position', '0 0 0.02');
    }
    if (s2) {
      s2.setAttribute('visible', false);
      s2.setAttribute('position', '0 6 0');
    }
  }

  const rightPanel = document.querySelector('#right-container');
  if (rightPanel) {
    const tabsToHide = rightPanel.querySelectorAll('.live-chart-tab, .performance-tab, .profile-tab, .financials-tab, .main-header');
    tabsToHide.forEach(t => {
      t.setAttribute('visible', false);
      if (t.classList.contains('live-chart-tab') || t.classList.contains('main-header')) {
        t.setAttribute('position', '0 6 0');
      } else {
        t.setAttribute('position', '0 6.16 0.025');
      }
    });
    
    const overviewTab = rightPanel.querySelector('.news-overview-tab');
    if (overviewTab) {
      overviewTab.setAttribute('visible', true);
      overviewTab.setAttribute('position', '0 0.04 0.02');
    }
  }
}

if (typeof window !== 'undefined') {
  window.VRNewsGraphController = {
    openNewsGraph,
    closeNewsGraph
  };
}
